export default __webpack_public_path__ + "static/media/litho-demo-consulting.6b19c9f1.jpg";